import { render, staticRenderFns } from "./MailPanel.vue?vue&type=template&id=4726bbb2&scoped=true&"
import script from "./MailPanel.vue?vue&type=script&lang=js&"
export * from "./MailPanel.vue?vue&type=script&lang=js&"
import style0 from "./MailPanel.vue?vue&type=style&index=0&id=4726bbb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4726bbb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4726bbb2')) {
      api.createRecord('4726bbb2', component.options)
    } else {
      api.reload('4726bbb2', component.options)
    }
    module.hot.accept("./MailPanel.vue?vue&type=template&id=4726bbb2&scoped=true&", function () {
      api.rerender('4726bbb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/mails/MailPanel.vue"
export default component.exports